module.exports = __webpack_public_path__ + "img/fruit-ground-cherries-190x100.9e02daef.jpg";